import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from '../../utils/compose';
import { connect } from 'react-redux';
import { Dialog, DialogTitle, DialogContent, DialogActions, FormHelperText, Button, Typography, makeStyles, Grid, useTheme, useMediaQuery } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import InlineSpinner from '../UI/InlineSpinner/InlineSpinner';
import PlanCard from '../Plans/PlanCard';
import { planActions } from '../../store/actions/plans/plans';
import { subscriptionBaseUrl, httpClient } from '../../http-client/http-client';
import { notificationActions } from '../../store/actions/notifications/notifications';

const useStyles = makeStyles(theme => ({
  root: {

  },
  cardContainer: {
    display: "flex"
  },
  dialogContent: {
    padding: "20px"
  }
}));

const ChangePlanDialog = ({ onClose,
                            open,
                            access_token,
                            planList,
                            subscription,
                            planFetching,
                            planError,
                            onFetchAvailablePlans,
                            onShowNotification,
                            hasPaymentMethod,
                            ...other }) => {
  const classes = useStyles();
  const [ error, setError ] = useState(null);
  const [ submitting, setSubmitting ] = useState(false);
  const { t } = useTranslation();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const orderedPlanList = [...planList];
  orderedPlanList.sort((a,b) => a.Price - b.Price);


  useEffect(() => {
    onFetchAvailablePlans();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  function handleCancel() {
    onClose(false);
  }

  async function planSelectedHandler(plan) {
    console.log(plan);

    const url = `${subscriptionBaseUrl}/update`;
    const model = {
      PlanId: plan.Id
    };

    try {
      const resp = await httpClient.post(url, access_token, model);
      const notification = {
        message: t("planChangedNotification"),
        options: {
          variant: "success"
        }
      };
      onShowNotification(notification);
      setSubmitting(false);
      onClose(true);
    }
    catch(error) {
      if(error.error.Error.startsWith("payment_processing_failed")) {
        setError(error.error.Error.split(':')[1]);
      } else {
        setError(error.error.HumanError);
      }
      setSubmitting(false);
    }
  }

  let plansElement = <InlineSpinner size="small" align="center" />;

  if(!planFetching) {
    if(planError) {
      plansElement = <Typography variant="body1">{t('somethingWentWrongWeb')}</Typography>
    } else {
      plansElement = (
        <Grid
          container
          spacing={5}
          alignItems="stretch"
          className={classes.root}
          >
            {orderedPlanList.map(p => {
              return (
                <Grid item key={p.Id} xs={12} md={12/orderedPlanList.length} className={classes.cardContainer}>
                  <PlanCard
                    plan={p}
                    withAction={planSelectedHandler}
                    submitting={submitting}
                    ctaType="update"
                    currentPlanId={subscription.data.Plan !== null ? subscription.data.Plan.Id : null}
                    warning={t('warnAddPaymentMethod')}
                    warningIf={!p.TrialPeriod && !hasPaymentMethod}
                  />
                </Grid>
              );
            })}
          </Grid>
      )
    }
  }

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      aria-labelledby="change-plan-dialog-title"
      open={open}
      fullScreen={fullScreen}
      {...other}
    >
      <DialogTitle id="change-plan-dialog-title">{t('changePlan')}</DialogTitle>
      <DialogContent dividers className={classes.dialogContent}>
        {plansElement}
      </DialogContent>
      <DialogActions>
        <FormHelperText className="Mui-error">{error}</FormHelperText>
        <Button onClick={handleCancel} color="primary" disabled={submitting}>{t('cancel')}</Button>
      </DialogActions>
    </Dialog>
  );
};

ChangePlanDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  access_token: state.oidc.user.access_token,
  subscription: state.subscription,
  planList: state.plans.data,
  planFetching: state.plans.fetching,
  planError: state.plans.error,
  hasPaymentMethod: state.paymentMethods.list.data.length > 0
});

const mapDispatchToProps = dispatch => ({
  onFetchAvailablePlans: () => dispatch(planActions.fetchAvailable()),
  onShowNotification: nt => dispatch(notificationActions.enqueueSnackbar(nt))
});

const composed = compose(
  connect(mapStateToProps, mapDispatchToProps)
)(ChangePlanDialog);

export default composed;